
(function () {

  const product_slider_v1_list = document.querySelectorAll('.js_product_slider_v1')

  for (let i = 0; i < product_slider_v1_list.length; i++) {
    const slider = product_slider_v1_list[i]
    initProductSliderV1(slider)
  }

  function initProductSliderV1 (slider) {
    const sliderWrapEl = slider.closest('.product-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let sliderOptions = {

      spaceBetween: 0,
      slidesPerView: 2,
      centeredSlides: true,
      loop: true,
      arrows: false,
      initialSlide: 2,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 4,
          initialSlide: 3,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 6,
        },
      },
      pagination: {
        el: ".js_product_slider_v1_pagination .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      navigation: {
        nextEl: ".js_product_slider_v1_nav .swiper-button-next",
        prevEl: ".js_product_slider_v1_nav .swiper-button-prev",
      },
      on: {
        // ready: function () {
        //   const activeLine = document.querySelector('.product-slider-v2-sec .swiper-pagination-bullet-active');
        //   const swiperPagination = document.querySelector('.product-slider-v2-sec .swiper-pagination-bullets-dynamic');
        //   if (activeLine && swiperPagination) {
        //     swiperPagination.style.left = 'calc(50% - ' + activeLine.style.left + ')';
        //   }
        // },
        slideChange: function () {
          const activeLine = document.querySelector('.product-slider-v2-sec .swiper-pagination-bullet-active');
          const swiperPagination = document.querySelector('.product-slider-v2-sec .swiper-pagination-bullets-dynamic');
          if (activeLine && swiperPagination) {
            swiperPagination.style.left = 'calc(50% - ' + activeLine.style.left + ')';
          }
        },
      },
    }

    // Override from theme
    // if (window.productSliderV1Override) {
    //   sliderOptions = window.productSliderV1Override(slider)
    // }

    new Swiper(slider, sliderOptions)
  }

})()
